/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import Loader from "../components/loader/loader";
import NoData from "../components/NoDataComp/NoData";
import BuyNftCard from "../components/Nft/BuyNftCard";
import { useNavigate, Link } from "react-router-dom";
import { FaCircleChevronLeft, FaCopy } from "react-icons/fa6";
import axios from "axios";
import { fireToast } from "../common/Toster";
import { ethers } from "ethers";
import { getNftsBuyedByUser } from "../services/NftServices";

const ViewAllBuyNfts = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [dbNfts, setDbNfts] = useState([]);
  const [nftOwnedByUser, setNftOwnedByUser] = useState([]);
  const [address, setAddress] = useState("");
  const [possestionsNfts, setPossestionsNfts] = useState([]);
  const [apiHit, setApiHit] = useState(false);

  const fetchBuyedNfts = async () => {
    try {
      const NftBuyedResponse = await getNftsBuyedByUser();
      if (NftBuyedResponse.status === 200) {
        setDbNfts(NftBuyedResponse?.data?.items);
        setApiHit(true);
      } else {
        throw new Error(NftBuyedResponse.error);
      }
    } catch (error) {
      console.error("Error fetching nft data:", error);
    }
  };

  const getAllNftsByUser = async () => {
    if (window.web3 && window.web3.currentProvider && window.web3.currentProvider.isCoinbaseWallet) {
      try {
        await window.ethereum.request({
          method: "wallet_switchEthereumChain",
          params: [{ chainId: "0x89" }],
          // params: [{ chainId: '0x5' }],
        });
      } catch (e) {
        // fireToast("error", "USER REJECTED THE REQUEST...");
        setLoading(false);
      }
      const provider = new ethers.providers.Web3Provider(window.web3.currentProvider);;
      await provider
        .send("eth_requestAccounts", [])
        .then(async (res) => {
          // console.log(res);
          setAddress(res?.[0]);
          try {
            const response = await axios({
              method: "get",
              url: `https://polygon-mainnet.g.alchemy.com/nft/v2/rvmpmREwuUjwDRUj3SBmkP6EDR0rSlVo/getNFTs?owner=${res?.[0]?res?.[0]:res?.result?.[0]}`,
            })
              .then(async (result1) => {
                // console.log(result,'result')

                try{
                  const response = await axios({
                    method: "get",
                    url: `https://polygon-mainnet.g.alchemy.com/nft/v2/rvmpmREwuUjwDRUj3SBmkP6EDR0rSlVo/getNFTs?owner=${res?.[0]?res?.[0]:res?.result?.[0]}&pageKey=${result1?.data?.pageKey}`,
                  })
                  .then((result)=>{
                setNftOwnedByUser(result1?.data?.ownedNfts.concat(result?.data?.ownedNfts));

                let ownNfts =result1?.data?.ownedNfts.concat(result?.data?.ownedNfts);
                let myOwnNFTAddress = [];
                for (let index = 0; index < ownNfts.length; index++) {
                  const element = ownNfts[index];
                  myOwnNFTAddress.push(
                    element?.contract?.address.toLowerCase()
                  );
                }
                let myWalletNFT = [];
                for (let index = 0; index < dbNfts.length; index++) {
                  const element = dbNfts[index];

                  console.log(element, element.contractAddress, "db nft");
                  if (
                    myOwnNFTAddress.includes(
                      element.contractAddress.toLowerCase()
                    )
                  ) {
                    // console.log("true case")
                    myWalletNFT.push(element);
                  }
                }

                setPossestionsNfts(myWalletNFT);

                setTimeout(() => {
                  setLoading(false);
                }, 2000);
              })
            }
            catch (error1) {
              fireToast("error", error1);
              console.log(error1);
            }
              })
              .catch((err) => {
                console.log(err, "error fetching nfts");
                setLoading(false);
              });
          } catch (error) {
            fireToast("error", error);
            console.log(error);
          }
        })
        .catch((e) => {
          console.log(e, ">>>>>>>>>>>>ERROR");
          setLoading(false);
        });
    } else {
      fireToast("error", "Metamask not detected");
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBuyedNfts();
  }, []);
  useEffect(() => {
    getAllNftsByUser();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [apiHit]);

  return loading ? (
    <Loader />
  ) : (
    <div className="p-4">
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Link
          className="back-btn fw-500 text-black py-4"
          onClick={() => navigate(-1)}
        >
          <i className="pe-2 align-middle">
            <FaCircleChevronLeft />
          </i>
          Back
        </Link>
      </div>

      <div className="dashboard-centerd">
        {possestionsNfts?.length > 0 ? (
          <div className="row g-0">
            <div className="row mb-4">
              {possestionsNfts?.map((item, i) => {
                return (
                  <div
                    key={i}
                    className="col-xxl-4 col-xl-4 col-md-6 col-12 mb-4"
                  >
                    <BuyNftCard
                      data={item}
                      fetchData={fetchBuyedNfts}
                      setLoading={setLoading}
                    />
                  </div>
                );
              })}
            </div>
          </div>
        ) : (
          <NoData />
        )}
      </div>
    </div>
  );
};

export default ViewAllBuyNfts;
